<template>
  <div class="expire_tip" v-if="status || dpsLimit.show">
    <template v-if="status">
      <div class="box day" v-if="expireTxt">
        <i class="el-icon-warning"></i>
        <span class="box-expire">{{ $t(expireTxt, [expireDay]) }}</span
        ><a class="box-purchase" :href="purchaseLink">{{ $t(purchaseTxt) }}</a
        ><i @click="showTip" class="box-close el-icon-close"></i>
      </div>
    </template>
    <div class="box card" v-if="dpsLimit.show">
      <i class="el-icon-warning"></i>
      <span class="box-expire" v-html="dpsLimitTips" @click="toLog"></span>
      <i @click="closeDpsTip" class="box-close el-icon-close"></i>
    </div>
  </div>
</template>

<script>
  import { updateDpsPopupStatus, getToken } from '@/utils/useStore'
  import { operateLog } from '@/utils/tool'
  import { mapState } from 'vuex'
  export default {
    name: 'ExpireTip',
    props: {},
    data() {
      return {
        expireTxt: null,
        expireDay: 0,
        purchaseTxt: null,
        purchaseLink: null,
        leftCard: 0,
        status: false
      }
    },
    computed: {
      ...mapState('user', {
        dpsLimit: state => state.dpsLimit,
        userInfo: state => state.user_info
      }),
      dayLimit() {
        return this.expireDay > 1
      },
      dpsLimitTips() {
        const { role = 0 } = this.userInfo
        const { type = 0, contact = '', show = false } = this.dpsLimit
        let tips = ''
        if (role === 1 || role === 2) {
          if (type === 1) {
            // dps未用完
            tips = this.$t('dps_less_10_admin')
          } else if (type === 2) {
            // dps用完了
            tips = this.$t('dps_use_up_admin')
          }
        } else if (role === 0) {
          const pre = 'mailto'
          const suf = contact
          if (type === 1) {
            // dps未用完
            tips = this.$t('dps_less_10_normal', [pre, suf])
          } else if (type === 2) {
            // dps用完了
            tips = this.$t('dps_use_up_normal', [pre, suf])
          }
        }
        if (show && tips) {
          this.$log.trace('reminder_renewal_dps')
        }
        return tips
      },
      cardLimit() {
        const token = getToken()
        const flag = window.localStorage.getItem('expireTipFlag') === token
        flag || window.localStorage.setItem('expireTipFlag', token)
        return this.expireDay > 15 && this.leftCard <= 5 && !flag
      }
    },
    mounted() {
      this.tipLogic()
    },
    methods: {
      toLog(e) {
        if (e.target.nodeName === 'A') {
          this.$log.action('click_buy_dps_service')
          const channel = (
            this.$store.state.user.user_info?.purchase_product?.purchase_channel || ''
          ).toLowerCase()
          updateDpsPopupStatus()
          operateLog('buy_dps', channel)
          if (channel.includes('ksj')) {
            this.$log.trace('show_contact_agent')
            // 'ksj': 代表当前公司曾通过代理商线下购买套餐或续费
            // 凡是之前通过代理商线下购买过的用户，就不再允许其通过线上购买或续费，仍然提示用户联系代理商进行购买
            this.$alert(this.$t('contact_channer_content'), this.$t('contact_channer_title'), {
              confirmButtonText: this.$t('confirm'),
              callback: () => {}
            })
          } else {
            this.$router.push('/payment/incrcard')
          }
        }
      },
      showTip() {
        this.status = !this.status
      },
      closeTip() {
        this.status = false
      },
      closeDpsTip() {
        updateDpsPopupStatus()
        this.$log.action('click_close_dps_renewal')
      },
      tipLogic() {
        let info = this.$store.state.user.user_info
        let expircy = info.purchase_product.expircy || 0
        let calcDay = Math.ceil((expircy - new Date().getTime() / 1000) / 86400)
        let leftCards = info.purchase_product.cr_fast_left
        this.expireDay = calcDay
        this.leftCard = leftCards
        this.status = true
        if (calcDay >= 15) return
        if (info.role !== 1) return
        if (
          !info.purchase_product.base_package ||
          info.purchase_product.base_package == 'freeby' ||
          info.purchase_product.base_package == 'freeby2'
        )
          return
        if ([1, 2].includes(info.package_level)) {
          this.expireTxt = 'free_expire_tip'
          this.purchaseTxt = 'expire_tip_purchase'
        } else {
          this.expireTxt = calcDay <= 0 ? 'account_overdue' : 'paid_expire_tip'
          this.purchaseTxt = 'expire_tip_renew'
        }
        this.purchaseLink = '/payment/price'
        this.status = this.setTipCookie()
      },
      setTipCookie() {
        let cookieTime = window.localStorage.getItem('_st') || 0
        let gapTime = !cookieTime ? new Date().getTime() - cookieTime : 0
        if (!cookieTime || gapTime / 1000 > 86400) {
          window.localStorage.setItem('_st', new Date().getTime())
          return true
        }
        return false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .expire_tip {
    position: fixed;
    top: 5px;
    left: 50%;
    z-index: 9999;
    transform: translateX(-50%);
    .el-icon-warning {
      color: var(--warning);
      font-size: 16px;
      margin-right: 6px;
    }
    .box {
      display: inline-flex;
      align-items: center;
      position: relative;
      padding: 9px 16px;
      background: var(--white);
      border-radius: 6px;
      border: 0;
      box-shadow: 0 8px 16px 0 var(--opacity-01);
      min-width: 100px;
      box-sizing: content-box;
      .box-expire {
        color: var(--gray-21);
        font-size: 14px;
      }
      .box-purchase {
        color: var(--blue);
        margin-left: 10px;
        margin-right: 14px;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
      .box-close {
        margin-top: 2px;
        font-size: 16px;
        color: var(--gray-5f);
        cursor: pointer;
      }
    }
    .card {
      display: flex;
      background: #fff0e7;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
      border-radius: 6px;
      border: 1px solid #ffc8a6;
      position: fixed;
      width: max-content;
      left: 50%;
      top: 66px;
      transform: translateX(-50%);
      .box-expire {
        color: var(--gray-5f);
      }
    }
    .rbg {
      .box-purchase {
        color: var(--blue);
      }
    }
  }
</style>
